import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const regularUrl = createApiUrl('/auth/token/')
const googleUrl = createApiUrl('/auth/convert-token/')

const regularLogin = async (creds) => {
    const credentials = {
        ...creds,
        grant_type: 'password',
        client_id: process.env.REACT_APP_REGULAR_LOGIN_CLIENT_ID,
        client_secret: process.env.REACT_APP_REGULAR_LOGIN_CLIENT_SECRET,
    }
    const res = await axios.post(regularUrl, credentials, tokenService.getAnonHeader())
    return res.data
}

const googleLogin = async (creds) => {
    const credentials = {
        ...creds,
        grant_type: 'convert_token',
        client_id: process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID,
        client_secret: process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_SECRET,
        backend: 'google-oauth2'
    }
    const res = await axios.post(googleUrl, credentials, tokenService.getAnonHeader())
    return res.data
}

const loginService = { regularLogin, googleLogin }

export default loginService